import { hideAlertMessageOnFocus, SendFormData } from "../../wcl-helpers";

document.addEventListener('DOMContentLoaded', () => {

    if (document.querySelector('.wcl-modal-account-details-form')) {
        const form = document.querySelector('.wcl-modal-account-details-form');
        const modalFormWrapper = form.querySelector('.wcl-modal-inner');
        const modalLayout = form.closest('.wcl-modal-layout');

        //Modal "Welcom"
        const modalWelcom = document.getElementById('wcl-welcom-popup');

        // Get variables
        const submitBtns = form.querySelectorAll('.wcl-js-account-details-button');

        // Get UI element
        const messageBlock = form.querySelector('.wcl-message-alert');
        const message = form.querySelector('.wcl-message');

        //Phone number mask
        let iti;

        const inputNumber = form.querySelector("#phone_number");

        if (inputNumber) {
            iti = window.intlTelInput(inputNumber, {
                initialCountry: 'lu',
                preferredCountries: ["al", "ad", "at", "by", "be", "ba", "bg", "hr", "cz", "dk",
                    "ee", "fo", "fi", "fr", "de", "gi", "gr", "va", "hu", "is", "ie", "it", "lv",
                    "li", "lt", "lu", "mk", "mt", "md", "mc", "me", "nl", "no", "pl", "pt", "ro",
                    "ru", "sm", "rs", "sk", "si", "es", "se", "ch", "ua", "gb"],
                separateDialCode: true,
                autoPlaceholder: "off",
                utilsScript: theme.themeUrl + "/build/vendor/js/intlTelInputUtils.js",
            });
        }

        submitBtns.forEach(button => {
            button.addEventListener('click', e => {

                e.preventDefault();

                // Get user ID
                const userId = form.dataset.userId;

                //Get full phone number
                const number = iti.getNumber();

                messageBlock.classList.remove('show', 'error', 'success');

                modalFormWrapper.classList.add('loading');

                let formData = new FormData(form);

                // Add wpnonce and User ID to data array
                // formData.append('wpnonce', wpnonce.value);
                formData.append('user_id', userId);
                formData.append('phone_number', number);


                SendFormData('account_details', formData).then(function (res) {
                    modalFormWrapper.classList.remove('loading');

                    let response = JSON.parse(res);

                    if (response.success == '1') {
                        modalLayout.classList.remove('active');
                        modalWelcom.classList.add('active');
                    } else {
                        throw response.message;
                    }

                }).catch(function (err) {
                    // Error
                    modalFormWrapper.classList.remove('loading');

                    messageBlock.classList.add('show', 'error');
                    message.innerHTML = err;

                    hideAlertMessageOnFocus(form, messageBlock);
                });
            });
        });
    }
});